import React, { createContext, useContext, useState } from 'react';

const LoadingContext = createContext({
  isLoading: true,
  setIsLoading: () => {},
  isInitialized: false,
  setIsInitialized: () => {}
});

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);

  return (
    <LoadingContext.Provider 
      value={{ 
        isLoading, 
        setIsLoading,
        isInitialized,
        setIsInitialized
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export default LoadingContext; 